import React, { useState } from 'react';
import styled from 'styled-components';
import { ConditionCheckContent } from './ConditionCheckContent';
import { ApplicantParticulars } from '../../AssessmentDetails';
import { AssessmentSidebar, ASSESSMENT_MODULE } from '../../../../components';
import { PAGE_TEXT } from '../../../../lang';
import { type SidebarData, Button } from '../../../../../../components';

export const DRCConditionCheck: React.FC = () => {
  const [activatedModuleId, setActivatedModuleId] = useState(
    ASSESSMENT_MODULE.CONDITION_CHECK,
  );

  const assessmentModulesMap: Partial<
    Record<ASSESSMENT_MODULE, { component: any; moduleTitle: string }>
  > = {
    [ASSESSMENT_MODULE.PARTICULARS]: {
      component: <ApplicantParticulars showGoDetail />,
      moduleTitle: PAGE_TEXT.DRC_ASSESSMENT_DETAILS.PARTICULARS.TITLE,
    },
    [ASSESSMENT_MODULE.CONDITION_CHECK]: {
      component: <ConditionCheckContent />,
      moduleTitle: PAGE_TEXT.DRC_ASSESSMENT_DETAILS.CONDITION_CHECK.TITLE,
    },
  };

  const activatedModule:
    | { component: React.ReactNode; moduleTitle: string }
    | undefined = assessmentModulesMap[activatedModuleId];

  const moduleComponent = activatedModule?.component ?? activatedModuleId;
  const moduleTitle = activatedModule?.moduleTitle ?? activatedModuleId;

  const sidebarData: SidebarData[] = [
    {
      id: ASSESSMENT_MODULE.PARTICULARS,
      name: PAGE_TEXT.DRC_ASSESSMENT_DETAILS.PARTICULARS.TITLE,
    },
    {
      id: ASSESSMENT_MODULE.CONDITION_CHECK,
      name: PAGE_TEXT.DRC_ASSESSMENT_DETAILS.CONDITION_CHECK.TITLE,
    },
  ];

  const handleChangeActivated = (activatedId: string): void => {
    setActivatedModuleId(activatedId as ASSESSMENT_MODULE);
  };

  const handleBack = (): void => {
    window.location.href = '/internal/dorpgs-homepage';
  };

  return (
    <PageContainer>
      <div className="sidebar-area">
        <AssessmentSidebar
          onChangeActivated={handleChangeActivated}
          currentActivatedModule={activatedModuleId}
          collapsible={true}
          sidebarData={sidebarData}
          drawerWidth={244}
          drawerInnerWidth="15rem"
          buttonField={
            <div className="submit-area">
              <Button variant="outlined" onClick={handleBack}>
                {PAGE_TEXT.BACK}
              </Button>
            </div>
          }
        />
      </div>
      <Container>
        <h1>{moduleTitle}</h1>
        <div className="form-area">{moduleComponent}</div>
      </Container>
    </PageContainer>
  );
};

const PageContainer = styled.div`
  display: flex;
  flex-direction: row;

  .sidebar-area {
    width: min-content;
  }

  h1 {
    margin-top: 2rem;
    font-size: 1.5rem;
    font-weight: 700;
    margin-bottom: 1rem;
    text-align: center;
    color: #951d1d;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;

  .sidebar-area {
    width: min-content;
  }

  .form-area {
    margin: 1rem;
  }

  .submit-area {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 0.5rem 1rem;
    margin-top: 18rem;
    button {
      margin: 0 1rem;
    }
  }
`;
